import React from 'react';
import { PaylinkStatus } from 'skipify-types';

import { getStatusLabel, getStatusUi } from '../../constants';
import { BaseStatusChip } from '.';

interface PaylinkStatusPillProps {
  status: PaylinkStatus;
  size?: 'small' | 'medium';
}

export const PaylinkStatusChip = ({
  status,
  size = 'small',
}: PaylinkStatusPillProps): JSX.Element => (
  <BaseStatusChip
    color={getStatusUi(status).color}
    icon={getStatusUi(status).icon}
    label={getStatusLabel(status)}
    size={size}
  />
);
